import { ReactComponent as Plus } from './plus.svg';

export default Plus;
